export default function tabs() {
  const $ = jQuery;

  $( '.tabs-nav__item-link').on( 'click', function( e ) {
    e.preventDefault();
    const breakPoint = 992;
    const parentContainer = $(this).attr('data-parent-container');
    const $parentContainer = $('#' + parentContainer);

    $parentContainer.find('.tabs-nav__item').removeClass('active');
    $(this).parents().eq(0).addClass('active');

    $parentContainer.find('.tabs-content__pane').hide();
    var tabid = $( this ).attr( 'href' );
    $( tabid ).show();
    
    $( '.tabs-content__pane' ).removeClass( 'active' );
    $( tabid ).addClass('active');

    
    if ( window.innerWidth < breakPoint ) {
      $('.tabs-nav').toggleClass('open');
      $('.tabs-dropdown-toggle').removeClass('open');
    }

    let title = $(this).text();
    $( '.tabs-dropdown-toggle span' ).text( title );

    $( this ).trigger( 'show' );
  });

  $('.tabs-dropdown-toggle').on( 'click', function( e ) {
    const expanded = $(this).attr('aria-expanded');
    (expanded == 'true' ? $(this).attr('aria-expanded', 'false') : $(this).attr('aria-expanded', 'true') );

    $(this).toggleClass('open');
    $('.tabs-nav').toggleClass('open');
  });

  // Enable linking to tabs.
  const url = window.location.hash;
  if ( url ) {
    $( '.tabs-nav__item' ).removeClass( 'active' );
    let tabLink = $( '.tabs-nav a[href="' + url + '"]');
    tabLink.addClass( 'active' );
    tabLink.parents().eq(0).addClass( 'active' );
    $( '.tabs-content__pane' ).removeClass( 'active' );
    $( '.tabs-content ' + url ).addClass( 'active' );
  } 

  // Change hash
  $('.tabs-nav__item').on('show', function ( e ) {
    history.pushState( null, null, e.target.hash );
  })
}
